import { createTheme } from '@mui/material';
import { brand } from './colors';
export { palette, brand, gradients, restriction } from './colors';
/**
 * MUI theme — built from the brand tokens in `./colors`.
 * Component-level overrides also live here so we have a single place to
 * tweak global look and feel.
 */
export var theme = createTheme({
    palette: {
        primary: brand.primary,
        secondary: brand.secondary,
        background: brand.background,
    },
    typography: {
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    fontWeight: 500,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: brand.primary.main,
                    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
                },
            },
        },
    },
});
